"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.voiceCallListResponseSchema = exports.voiceCallListQuerySchema = exports.voiceCallDetailSchema = exports.voiceVoicemailSchema = exports.voiceRecordingPlaybackSchema = exports.voiceRecordingSchema = exports.voiceCallLegSchema = exports.voiceCallSchema = exports.voiceOutboundCallIntentSchema = exports.createVoiceOutboundCallIntentRequestSchema = exports.voiceBrowserSessionSchema = exports.voiceCallContextSchema = exports.updateVoiceSettingsRequestSchema = exports.assignExistingVoiceNumberRequestSchema = exports.voiceSettingsSchema = exports.voiceReadinessSchema = exports.voiceOwnedNumberListResponseSchema = exports.voiceOwnedNumberSchema = exports.voiceProvisioningReadinessSchema = exports.voiceProviderConnectionStatusSchema = exports.voiceNumberProviderModeSchema = exports.voicePhoneNumberSummarySchema = exports.voiceReadinessBlockerSchema = exports.voiceSetupStateSchema = exports.voiceRoutingPolicySchema = exports.voiceVoicemailFallbackRouteSchema = exports.voiceInboundRouteSchema = exports.voiceVoicemailConfigurationSchema = exports.voiceBusinessTimezoneSchema = exports.voiceWeeklyHoursSchema = exports.voiceBusinessHourSchema = exports.voiceWeekdaySchema = exports.VOICE_VOICEMAIL_MAX_DURATION_SECONDS = exports.VOICE_VOICEMAIL_MIN_DURATION_SECONDS = exports.VOICE_VOICEMAIL_GREETING_MAX_LENGTH = exports.VOICE_OUTBOUND_CALL_INTENT_TTL_SECONDS = exports.VOICE_BROWSER_SESSION_TTL_SECONDS = exports.VOICE_RING_TIMEOUT_MAX_SECONDS = exports.VOICE_RING_TIMEOUT_MIN_SECONDS = exports.voiceRecordingModeSchema = exports.voiceCallLegEndpointTypeSchema = exports.voiceCallStatusSchema = exports.voiceCallDirectionSchema = exports.voiceE164NumberSchema = exports.voiceRecordingIdSchema = exports.voiceCallIdSchema = void 0;
const zod_1 = require("zod");
const pagination_1 = require("./pagination");
const phone_tracking_1 = require("./phone-tracking");
exports.voiceCallIdSchema = zod_1.z.string().uuid();
exports.voiceRecordingIdSchema = zod_1.z.string().uuid();
exports.voiceE164NumberSchema = zod_1.z.string().regex(/^\+[1-9][0-9]{7,14}$/);
exports.voiceCallDirectionSchema = zod_1.z.enum(["INBOUND", "OUTBOUND"]);
exports.voiceCallStatusSchema = zod_1.z.enum([
    "QUEUED",
    "RINGING",
    "IN_PROGRESS",
    "COMPLETED",
    "MISSED",
    "FAILED",
    "CANCELED",
]);
exports.voiceCallLegEndpointTypeSchema = zod_1.z.enum([
    "PSTN",
    "BROWSER",
    "MOBILE",
    "FORWARDING",
    "VOICEMAIL",
]);
exports.voiceRecordingModeSchema = zod_1.z.enum([
    "OFF",
    "INBOUND",
    "OUTBOUND",
    "ALL",
]);
exports.VOICE_RING_TIMEOUT_MIN_SECONDS = 10;
exports.VOICE_RING_TIMEOUT_MAX_SECONDS = 60;
exports.VOICE_BROWSER_SESSION_TTL_SECONDS = 300;
exports.VOICE_OUTBOUND_CALL_INTENT_TTL_SECONDS = 120;
exports.VOICE_VOICEMAIL_GREETING_MAX_LENGTH = 500;
exports.VOICE_VOICEMAIL_MIN_DURATION_SECONDS = 10;
exports.VOICE_VOICEMAIL_MAX_DURATION_SECONDS = 300;
exports.voiceWeekdaySchema = zod_1.z.enum([
    "MONDAY",
    "TUESDAY",
    "WEDNESDAY",
    "THURSDAY",
    "FRIDAY",
    "SATURDAY",
    "SUNDAY",
]);
exports.voiceBusinessHourSchema = zod_1.z
    .object({
    weekday: exports.voiceWeekdaySchema,
    isOpen: zod_1.z.boolean(),
    startMinute: zod_1.z.number().int().min(0).max(1439).nullable(),
    endMinute: zod_1.z.number().int().min(1).max(1440).nullable(),
})
    .strict()
    .superRefine((value, context) => {
    if (!value.isOpen) {
        if (value.startMinute !== null || value.endMinute !== null) {
            context.addIssue({
                code: "custom",
                message: "Closed days cannot include business hours.",
            });
        }
        return;
    }
    if (value.startMinute === null ||
        value.endMinute === null ||
        value.startMinute >= value.endMinute) {
        context.addIssue({
            code: "custom",
            message: "Open days require a valid start and end time.",
        });
    }
});
exports.voiceWeeklyHoursSchema = zod_1.z
    .array(exports.voiceBusinessHourSchema)
    .length(7)
    .superRefine((days, context) => {
    if (new Set(days.map((day) => day.weekday)).size !== 7) {
        context.addIssue({
            code: "custom",
            message: "Weekly hours must include each weekday once.",
        });
    }
});
exports.voiceBusinessTimezoneSchema = zod_1.z
    .string()
    .trim()
    .min(1)
    .max(64)
    .refine(isSupportedTimeZone, "A valid IANA timezone is required.");
exports.voiceVoicemailConfigurationSchema = zod_1.z.object({
    enabled: zod_1.z.boolean(),
    greeting: zod_1.z.string().trim().min(1).max(exports.VOICE_VOICEMAIL_GREETING_MAX_LENGTH),
    maxDurationSeconds: zod_1.z
        .number()
        .int()
        .min(exports.VOICE_VOICEMAIL_MIN_DURATION_SECONDS)
        .max(exports.VOICE_VOICEMAIL_MAX_DURATION_SECONDS),
});
exports.voiceInboundRouteSchema = zod_1.z.discriminatedUnion("mode", [
    zod_1.z.object({ mode: zod_1.z.literal("REJECT") }).strict(),
    zod_1.z.object({ mode: zod_1.z.literal("VOICEMAIL") }).strict(),
    zod_1.z
        .object({
        mode: zod_1.z.literal("TEAM"),
        ringTimeoutSeconds: zod_1.z
            .number()
            .int()
            .min(exports.VOICE_RING_TIMEOUT_MIN_SECONDS)
            .max(exports.VOICE_RING_TIMEOUT_MAX_SECONDS),
    })
        .strict(),
    zod_1.z
        .object({
        mode: zod_1.z.literal("FORWARD"),
        forwardingNumber: exports.voiceE164NumberSchema,
        ringTimeoutSeconds: zod_1.z
            .number()
            .int()
            .min(exports.VOICE_RING_TIMEOUT_MIN_SECONDS)
            .max(exports.VOICE_RING_TIMEOUT_MAX_SECONDS),
    })
        .strict(),
]);
exports.voiceVoicemailFallbackRouteSchema = zod_1.z.discriminatedUnion("mode", [
    zod_1.z.object({ mode: zod_1.z.literal("REJECT") }).strict(),
    zod_1.z.object({ mode: zod_1.z.literal("VOICEMAIL") }).strict(),
]);
exports.voiceRoutingPolicySchema = zod_1.z.object({
    timezone: exports.voiceBusinessTimezoneSchema,
    weeklyHours: exports.voiceWeeklyHoursSchema,
    openRoute: exports.voiceInboundRouteSchema,
    closedRoute: exports.voiceVoicemailFallbackRouteSchema,
    noAnswerRoute: exports.voiceVoicemailFallbackRouteSchema,
});
exports.voiceSetupStateSchema = zod_1.z.enum([
    "LOCKED",
    "SETUP_REQUIRED",
    "READY",
    "ATTENTION_REQUIRED",
]);
exports.voiceReadinessBlockerSchema = zod_1.z.enum([
    "ENTITLEMENT_REQUIRED",
    "PROVIDER_ACCOUNT_REQUIRED",
    "PHONE_NUMBER_REQUIRED",
    "PHONE_NUMBER_NOT_ACTIVE",
    "VOICE_NOT_ENABLED",
    "INBOUND_ROUTE_REQUIRED",
]);
exports.voicePhoneNumberSummarySchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    e164Number: exports.voiceE164NumberSchema,
    status: zod_1.z.enum(["PROVISIONING", "ACTIVE", "INACTIVE", "RELEASED"]),
});
exports.voiceNumberProviderModeSchema = zod_1.z.enum([
    "LOCAL_CAPTURE",
    "TWILIO",
    "UNAVAILABLE",
]);
exports.voiceProviderConnectionStatusSchema = zod_1.z.enum([
    "READY",
    "UNAVAILABLE",
    "ERROR",
]);
exports.voiceProvisioningReadinessSchema = zod_1.z.object({
    provider: exports.voiceNumberProviderModeSchema,
    configured: zod_1.z.boolean(),
    production: zod_1.z.boolean(),
    connectionStatus: exports.voiceProviderConnectionStatusSchema,
    safeError: zod_1.z.string().max(240).nullable(),
    phoneNumber: exports.voicePhoneNumberSummarySchema.nullable(),
});
exports.voiceOwnedNumberSchema = zod_1.z.object({
    e164Number: exports.voiceE164NumberSchema,
    displayName: zod_1.z.string().trim().min(1).max(80),
    capabilities: zod_1.z.object({
        voice: zod_1.z.boolean(),
        sms: zod_1.z.boolean(),
        mms: zod_1.z.boolean(),
    }),
});
exports.voiceOwnedNumberListResponseSchema = zod_1.z.object({
    items: zod_1.z.array(exports.voiceOwnedNumberSchema),
});
exports.voiceReadinessSchema = zod_1.z.object({
    appId: zod_1.z.literal("crewfsm.voice"),
    entitled: zod_1.z.boolean(),
    setupState: exports.voiceSetupStateSchema,
    blockers: zod_1.z.array(exports.voiceReadinessBlockerSchema),
    phoneNumber: exports.voicePhoneNumberSummarySchema.nullable(),
    capabilities: zod_1.z.object({
        canRead: zod_1.z.boolean(),
        canCall: zod_1.z.boolean(),
        canManage: zod_1.z.boolean(),
        canListenToRecordings: zod_1.z.boolean(),
    }),
});
exports.voiceSettingsSchema = zod_1.z.object({
    businessId: zod_1.z.string().uuid(),
    enabled: zod_1.z.boolean(),
    inboundCallingEnabled: zod_1.z.boolean(),
    outboundCallingEnabled: zod_1.z.boolean(),
    voicemailEnabled: zod_1.z.boolean(),
    recordingMode: exports.voiceRecordingModeSchema,
    inboundRoute: exports.voiceInboundRouteSchema,
    routingPolicy: exports.voiceRoutingPolicySchema,
    voicemail: exports.voiceVoicemailConfigurationSchema,
    phoneNumber: exports.voicePhoneNumberSummarySchema.nullable(),
    updatedAt: zod_1.z.string().datetime({ offset: true }).nullable(),
});
exports.assignExistingVoiceNumberRequestSchema = zod_1.z.object({
    e164Number: exports.voiceE164NumberSchema,
});
exports.updateVoiceSettingsRequestSchema = zod_1.z.object({
    enabled: zod_1.z.boolean(),
    inboundCallingEnabled: zod_1.z.boolean(),
    outboundCallingEnabled: zod_1.z.boolean().optional(),
    voicemailEnabled: zod_1.z.boolean(),
    inboundRoute: exports.voiceInboundRouteSchema.optional(),
    routingPolicy: exports.voiceRoutingPolicySchema.optional(),
    voicemail: exports.voiceVoicemailConfigurationSchema.optional(),
});
exports.voiceCallContextSchema = zod_1.z.object({
    customerId: zod_1.z.string().uuid().nullable(),
    leadId: zod_1.z.string().uuid().nullable(),
    jobId: zod_1.z.string().uuid().nullable(),
    attribution: phone_tracking_1.phoneInboundAttributionSchema.nullable().optional(),
});
exports.voiceBrowserSessionSchema = zod_1.z.object({
    token: zod_1.z.string().min(32).max(8_192),
    identity: zod_1.z.string().regex(/^(?:u|m)_[a-f0-9]{32}$/),
    expiresAt: zod_1.z.string().datetime({ offset: true }),
    workspaces: zod_1.z.array(zod_1.z.object({
        tenantId: zod_1.z.string().uuid(),
        businessId: zod_1.z.string().uuid(),
        tenantName: zod_1.z.string().trim().min(1).max(160),
        businessName: zod_1.z.string().trim().min(1).max(160),
        canCall: zod_1.z.boolean(),
        canReceive: zod_1.z.boolean(),
    })),
});
exports.createVoiceOutboundCallIntentRequestSchema = zod_1.z.object({
    toNumber: exports.voiceE164NumberSchema,
    context: exports.voiceCallContextSchema.optional(),
});
exports.voiceOutboundCallIntentSchema = zod_1.z.object({
    intentId: zod_1.z.string().uuid(),
    callId: exports.voiceCallIdSchema,
    expiresAt: zod_1.z.string().datetime({ offset: true }),
});
exports.voiceCallSchema = zod_1.z.object({
    id: exports.voiceCallIdSchema,
    businessId: zod_1.z.string().uuid(),
    direction: exports.voiceCallDirectionSchema,
    status: exports.voiceCallStatusSchema,
    fromNumber: zod_1.z.string().min(1).max(32),
    toNumber: zod_1.z.string().min(1).max(32),
    contactName: zod_1.z.string().max(160).nullable(),
    assignedToMembershipId: zod_1.z.string().uuid().nullable(),
    context: exports.voiceCallContextSchema,
    startedAt: zod_1.z.string().datetime({ offset: true }).nullable(),
    answeredAt: zod_1.z.string().datetime({ offset: true }).nullable(),
    endedAt: zod_1.z.string().datetime({ offset: true }).nullable(),
    durationSeconds: zod_1.z.number().int().nonnegative().nullable(),
    recordingAvailable: zod_1.z.boolean(),
    voicemailAvailable: zod_1.z.boolean(),
    createdAt: zod_1.z.string().datetime({ offset: true }),
    updatedAt: zod_1.z.string().datetime({ offset: true }),
});
exports.voiceCallLegSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    direction: exports.voiceCallDirectionSchema,
    status: exports.voiceCallStatusSchema,
    endpointType: exports.voiceCallLegEndpointTypeSchema,
    fromAddress: zod_1.z.string().max(320).nullable(),
    toAddress: zod_1.z.string().max(320).nullable(),
    startedAt: zod_1.z.string().datetime({ offset: true }).nullable(),
    answeredAt: zod_1.z.string().datetime({ offset: true }).nullable(),
    endedAt: zod_1.z.string().datetime({ offset: true }).nullable(),
    durationSeconds: zod_1.z.number().int().nonnegative().nullable(),
});
exports.voiceRecordingSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    status: zod_1.z.enum(["PROCESSING", "AVAILABLE", "FAILED", "DELETED"]),
    durationSeconds: zod_1.z.number().int().nonnegative().nullable(),
    sizeBytes: zod_1.z.number().int().nonnegative().nullable(),
    mimeType: zod_1.z.string().min(1).max(120).nullable(),
    checksumSha256: zod_1.z
        .string()
        .regex(/^[a-f0-9]{64}$/)
        .nullable(),
    safeError: zod_1.z.string().max(500).nullable(),
    canPlayback: zod_1.z.boolean(),
    consentStatus: zod_1.z
        .enum(["NOT_APPLICABLE", "UNKNOWN", "DISCLOSED", "GRANTED", "DENIED"])
        .optional(),
    disclosurePlayedAt: zod_1.z
        .string()
        .datetime({ offset: true })
        .nullable()
        .optional(),
    retentionExpiresAt: zod_1.z
        .string()
        .datetime({ offset: true })
        .nullable()
        .optional(),
    legalHold: zod_1.z.boolean().optional(),
    createdAt: zod_1.z.string().datetime({ offset: true }),
    availableAt: zod_1.z.string().datetime({ offset: true }).nullable(),
    deletedAt: zod_1.z.string().datetime({ offset: true }).nullable(),
});
exports.voiceRecordingPlaybackSchema = zod_1.z.object({
    recordingId: zod_1.z.string().uuid(),
    url: zod_1.z.string().url(),
    expiresAt: zod_1.z.string().datetime({ offset: true }),
});
exports.voiceVoicemailSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    recordingId: zod_1.z.string().uuid().nullable(),
    callerNumber: zod_1.z.string().max(32),
    durationSeconds: zod_1.z.number().int().nonnegative().nullable(),
    createdAt: zod_1.z.string().datetime({ offset: true }),
});
exports.voiceCallDetailSchema = exports.voiceCallSchema.extend({
    legs: zod_1.z.array(exports.voiceCallLegSchema),
    recordings: zod_1.z.array(exports.voiceRecordingSchema),
    voicemail: exports.voiceVoicemailSchema.nullable(),
});
exports.voiceCallListQuerySchema = pagination_1.paginationQuerySchema.extend({
    direction: exports.voiceCallDirectionSchema.optional(),
    status: exports.voiceCallStatusSchema.optional(),
    search: zod_1.z.string().trim().max(160).optional(),
});
exports.voiceCallListResponseSchema = zod_1.z.object({
    items: zod_1.z.array(exports.voiceCallSchema),
    total: zod_1.z.number().int().nonnegative(),
    pageInfo: pagination_1.pageInfoSchema,
});
function isSupportedTimeZone(value) {
    try {
        new Intl.DateTimeFormat("en-US", { timeZone: value }).format();
        return true;
    }
    catch {
        return false;
    }
}
//# sourceMappingURL=voice.js.map